import { render, staticRenderFns } from "./PaymentDetailItem.vue?vue&type=template&id=90bea5b6"
import script from "./PaymentDetailItem.vue?vue&type=script&lang=js"
export * from "./PaymentDetailItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports